import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { getClientID } from "../../services/clientCode";
import { sendOtp } from "../../services/sendOtp";
import { verifyOtp } from "../../services/verifyOtp";

import { toast } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const params = useParams();
  const { client_code } = params;

  const [linkID, setlinkID] = useState("");

  useEffect(() => {
    getClientData();
  }, []);

  const getClientData = async () => {
    try {
      const data = {
        code: client_code,
      };
      const response = await getClientID(data);

      if (response?.status) {
        const result = response?.data?.data;
        const linkData = result?.URL;

        if (
          !linkData ||
          parseInt(linkData.link_time || 0) <= 0 ||
          linkData.is_active !== "Yes"
        ) {
          console.log("Client URL is not active or link time expired");
          navigate("/inactive");
          return;
        }

        setlinkID(linkData.link_id);
        return linkData;
      }

      // if (response?.status) {
      //   const result = response?.data?.data;
      //   // console.log("result", result);
      //   if (result?.URL?.is_active === "Yes") {
      //     setlinkID(result?.URL?.link_id);
      //     return result?.URL;
      //   } else {
      //     console.log("Client URL is not active or missing");
      //     navigate("/inactive");
      //   }
      // }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();

    if (mobile.trim().length !== 10) {
      // alert("Please enter a valid 10-digit mobile number");
      toast.error("Please enter a valid 10-digit mobile number! ❌");
      return;
    }

    const payload = {
      phone: mobile,
      link_id: linkID,
    };

    try {
      const response = await sendOtp(payload);

      if (response?.status) {
        const result = response.data;

        if (result?.status) {
          toast.success(`${result.message} ✅`);
          setStep(2);
        } else {
          // console.error("Error:", result?.message);
          toast.error(`${result?.message} ❌`);
          setMobile("");
        }
      } else {
        console.error("Error: OTP not sent!");
        toast.error("OTP not sent! ❌");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("An unexpected error occurred. Please try again. ❌");
    }
  };
  // Verify OTP API call
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (otp.length !== 6) {
      // alert("Please enter a valid 6-digit OTP");
      toast.error("Please enter a valid 6-digit OTP ❌");
      return;
    }

    const payload = {
      phone: mobile,
      otp: otp,
    };

    try {
      const response = await verifyOtp(payload);
      if (response?.status) {
        const result = response.data;

        if (result?.status) {
          toast.success(`${result?.message}  ✅`);
          localStorage.setItem("token", response.data.token);
          navigate(`/app/${client_code}`);
        } else {
          console.error("Error:", result?.message);
          // alert(`Error: ${result?.message}`);
          toast.error(`${result?.message} ❌`);
          setOtp("");
        }
      } else {
        console.error("Error: OTP not sent!");
        // alert("Error: OTP not sent!");
        toast.error(" OTP not sent! ❌");
      }
    } catch (error) {
      // alert("Invalid OTP");
      toast.error("Invalid OTP ❌");
      console.error("Verify OTP Error:", error);
      setOtp("");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#F7F6F1]">
      <div className="p-4 rounded-lg w-50">
        <h2 className="text-3xl font-bold mb-6 text-center">Welcome</h2>
        {step === 1 ? (
          // Step 1: Enter Mobile Number
          <form onSubmit={handleSendOtp} className="space-y-4">
            <input
              type="number"
              name="mobile"
              value={mobile}
              // onChange={(e) => setMobile(e.target.value)}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                setMobile(value);
              }}
              placeholder="Enter Mobile Number"
              className="w-full px-3 py-2 border rounded-3xl focus:outline-none focus:ring focus:ring-blue-200"
              required
            />
            <button
              type="submit"
              className="w-full bg-[#AD826D] text-white py-2 px-4 rounded-3xl hover:opacity-75"
            >
              Send OTP
            </button>
          </form>
        ) : (
          // Step 2: Enter OTP
          <form onSubmit={handleVerifyOtp} className="space-y-4">
            <input
              type="number"
              name="otp"
              value={otp}
              // onChange={(e) => setOtp(e.target.value)}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                setOtp(value);
              }}
              placeholder="Enter OTP"
              className="w-full px-3 py-2 border rounded-3xl focus:outline-none focus:ring focus:ring-blue-200"
              required
            />
            <button
              type="submit"
              className="w-full bg-[#AD826D] text-white py-2 px-4 rounded-3xl hover:opacity-75"
            >
              Verify OTP
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Login;
